// FIXME we should have the creation date on it here as well, so that we create the task no on the fly
import {Member} from "@/models/member.ts";
import {z} from "zod";
import {ServiceWithGroupId} from "./service";
import {SubmissionChannel} from "@/models/submission-channel.ts";


export type OrderOverviewMember = {
    id: string,
    salutation?: string,
    title?: string,
    firstName: string,
    lastName: string,
}

export type OrderOverviewItem = {
    id: string,
    orderNo: string,
    client: OrderOverviewMember,
    helper: OrderOverviewMember,
    service: string,
    orderDate: string,
    comments: string,
    status: "Open" | "Completed" | "Cancelled",
    completedAt?: string,
    cancelledAt?: string,
}

export type OrderDetailsMember = {
    id: string,
    salutation?: string,
    title?: string,
    firstName: string,
    lastName: string,
    memberNo: number,
    points?: number,
}

export type OrderDetailsService = {
    id: string,
    name: string,
}

export type OrderDetailsUser = {
    id: string,
    name: string,
    username: string
}

export type OrderDetailsMetadata = {
    date: string,
    user: OrderDetailsUser
}

export type OrderDetails = {
    id: string,
    orderNo: string,
    orderStatus: string, // enum!
    client: OrderDetailsMember,
    helper: OrderDetailsMember | null,
    service: OrderDetailsService,
    submissionChannel: SubmissionChannel,
    items: OrderItem[],
    orderDate?: string,
    comments?: string,
    mileage?: number,
    reimbursableAmount?: number,
    payWithPoints: boolean,
    donationAmount?: number,
    pointsDonatedToSocialAccount: boolean,
    paidFromSocialAccount: boolean,
    settlementDate?: string,
    creationDetails: OrderDetailsMetadata,
    updateDetails?: OrderDetailsMetadata,
    cancellationDetails?: OrderDetailsMetadata,
    completionDetails?: OrderDetailsMetadata,
    voucherNumber?: number,
}

// Servicegruppe
export type ServiceGroup = {
    id: string,
    name: string,
    description?: string,
}


// Einzelne Positionen
export type OrderItem = {
    id: string,
    date: string,
    startTime: string,
    endTime: string,
    priceInPoints: number,
    priceInFiat: number,
    createdAt: string,
    updatedAt?: string,
}


// Basisschema für Auftragsdaten (ohne IDs)
export type OrderFormData = {
    orderDate?: string;
    client?: Member;
    helper?: Member;
    service?: ServiceWithGroupId;
};

// FIXME i18n
// Schema für das Erstellen eines neuen Auftrags (mit erforderlichen IDs)
export const createOrderSchema = z.object({
    orderDate: z.string().min(1, "Das Auftragsdatum ist erforderlich"),
    clientId: z.string().uuid("Bitte wählen Sie einen gültigen Auftraggeber aus"),
    serviceId: z.string({error: "orderForm.create.errors.service-not-selected"}).uuid("orderForm.create.errors.invalid-service-uuid"),
    helperId: z.string().optional(),
    submissionChannelId: z.string().uuid("Bitte wählen Sie einen gültigen Übermittlungsweg aus"),
    comments: z.string().optional()
});

// Typ für das Create-Formular
export type CreateOrderFormData = z.infer<typeof createOrderSchema>;


// Modell für einen neuen Auftrag
export interface CreateOrderRequest {
    orderDate: string;
    clientId: string;
    serviceId: string;
    helperId: string;
    comments?: string;
    submissionChannelId: string;
}

// Response nach dem Erstellen eines Auftrags
export interface CreateOrderResponse {
    id: string;
    orderNo: string;
    orderDate: string;
    clientId: string;
    serviceId: string;
    helperId: string;
    comments?: string;
    submissionChannelId: string;
    createdAt: string;
}

// Request für das Aktualisieren eines Auftrags
export interface UpdateOrderRequest {
    clientId: string;
    serviceId: string;
    helperId?: string;
    comments?: string;
    submissionChannelId: string;
    mileage?: number | null;
    reimbursableAmount?: number | null;
    payWithPoints?: boolean | null;
    paidFromSocialAccount?: boolean | null;
    donationAmount?: number | null;
}

// Response nach dem Aktualisieren eines Auftrags
export interface UpdateOrderResponse {
    id: string;
    orderNo: string;
    orderDate: string;
    clientId: string;
    serviceId: string;
    helperId?: string;
    comments?: string;
    submissionChannelId: string;
    updatedAt: string;
}
